<template>
  <VaModal
    v-model="store.isModalOpen"
    size="small"
    title="Ek Güvenlik Doğrulaması"
    hide-default-actions
    no-outside-dismiss
    no-esc-dismiss
    @close="onClose"
  >
    <div class="p-2 space-y-4">
      <p class="text-sm text-secondary">Yeni iş yeri eklemek için lütfen yetkili bilgilerini giriniz.</p>
      <VaInput v-model="username" label="Kullanıcı Adı" class="w-full" @keyup.enter="onSubmit" />
      <VaInput v-model="password" type="password" label="Şifre" class="w-full" @keyup.enter="onSubmit" />
      <div v-if="error" class="text-danger text-xs">{{ error }}</div>
    </div>
    <template #footer>
      <div class="flex justify-end gap-2 p-2">
        <VaButton preset="secondary" @click="onClose">İptal</VaButton>
        <VaButton @click="onSubmit">Doğrula</VaButton>
      </div>
    </template>
  </VaModal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useTenantGuardStore } from '../stores/tenant-guard'
import { useRouter } from 'vue-router'

const store = useTenantGuardStore()
const router = useRouter()

const username = ref('')
const password = ref('')
const error = ref('')

const onSubmit = () => {
  error.value = ''
  const success = store.verify(username.value, password.value)
  if (success) {
    username.value = ''
    password.value = ''
    if (store.redirectAfterSuccess) {
      router.push({ name: store.redirectAfterSuccess })
    }
  } else {
    error.value = 'Hatalı kullanıcı adı veya şifre!'
  }
}

const onClose = () => {
  store.closeModal()
  username.value = ''
  password.value = ''
  error.value = ''
  // Sadece doğrulama başarısızsa ve şu an newTenant sayfasındaysak geri yönlendir
  if (!store.isVerified && router.currentRoute.value.name === 'newTenant') {
    router.push({ name: 'tenants' })
  }
}
</script>
